import { makeStyles, Theme } from '@material-ui/core'
import COLORS from 'lib/colors'
import { ReactElement } from 'react'
import Col from 'shared-components/col'
import Typography from 'shared-components/typography'
import useMobile from 'components/hooks/useMobile'

const useStyle = makeStyles((theme: Theme) => ({
	root: {
		backgroundColor: COLORS.primary,
		boxShadow: '0px 4px 10px rgba(138, 84, 232, 0.2)',
		padding: '20px 200px 20px 200px',
		borderBottomLeftRadius: 75,
		borderBottomRightRadius: 75,
		width: '100%',
		zIndex: 2,
		[theme.breakpoints.down('md')]: {
			paddingLeft: 50,
			paddingRight: 50,
		},
	},
	title: {
		marginBottom: 8,
	},
}))

interface IProps {
	title: string
	subtitle: string
}

export default function QuizHeader(props: IProps): ReactElement {
	const classes = useStyle()
	const mobile = useMobile()
	return (
		<Col className={classes.root} align='center'>
			<Typography fontColor='#fff' variant={ mobile ? 'h6' : 'h4'} fontWeight='600' className={classes.title} style={{padding: '0 20px', textAlign: 'center'}}>
				{props.title}
			</Typography>
			<Typography style={{padding: '0 20px', textAlign: 'center'}} fontColor='#fff'>{props.subtitle}</Typography>
		</Col>
	)
}
